import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"

const TelegramIconSvg = ({
  color = "primary",
  bg = "#f5f9f9",
  iconStyle,
  ...rest
}) => {
  return (
    <Svg
      fill="none"
      height="33"
      viewBox="-4 0 27 17"
      width="33"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        clip-rule="evenodd"
        d="m1.52706 8.4706c4.65112-2.02641 7.75259-3.36235 9.30444-4.00781 4.4308-1.84291 5.3514-2.16304 5.9515-2.17361.132-.00233.4271.03038.6183.18549.1614.13097.2058.3079.227.43207.0213.12418.0478.40705.0267.62808-.2401 2.52281-1.279 8.64498-1.8076 11.47058-.2236 1.1956-.664 1.5965-1.0903 1.6357-.9265.0853-1.6301-.6123-2.5275-1.2005-1.4042-.9205-2.1975-1.4935-3.56053-2.3917-1.57523-1.0381-.55407-1.6086.34364-2.541.23494-.244 4.31719-3.95714 4.39619-4.29398.0099-.04213.0191-.19916-.0742-.28208-.0933-.08291-.231-.05456-.3303-.03201-.1409.03197-2.3841 1.51468-6.72982 4.44817-.63675.4372-1.21349.6502-1.73023.6391-.56966-.0123-1.66547-.3221-2.48009-.5869-.99916-.3248-1.793275-.49654-1.724125-1.04813.036017-.2873.43166-.58112 1.186925-.88147z"
        fill={color}
        fill-rule="evenodd"
      />
    </Svg>
  )
}

export default TelegramIconSvg
